export default __webpack_public_path__ + "static/media/react_logo.20adfb35.png";